import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import colors from 'vuetify/lib/util/colors';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@mdi/font/css/materialdesignicons.css';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Toasted from 'vue-toasted';

const vuetifyOptions = {};
Vue.use(Vuetify, {
  iconfont: 'mdi',
});
Vue.config.productionTip = false;
Vue.use(Toasted, { position: 'bottom-right', theme: 'bubble', singleton: 'true', className: 'toast-styles' });

new Vue({
  vuetify: new Vuetify(vuetifyOptions),
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
export default new Vuetify({
  icons: {
    iconfont: 'fa4',
  },
  theme: {
    themes: {
      light: {
        primary: colors.red.darken1, // #E53935
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base, // #3F51B5
      },
    },
  },
});
